<template>
  <div class="base-container bg-default d-flex flex-column">
    <div class="white card">
      <v-container>
        <v-row class="d-flex flex-column img">
          <v-img src="@/assets/img-finalizado.png" max-width="200" />
          <h4 class="secondary-font text-center">Obrigado por preencher!</h4>
          <v-btn @click="iniciarAtendimento" color="primary" :disabled="loading" :loading="loading"
            class="secondary-font text-capitalize font-weight-black" rounded>
            Iniciar atendimento
          </v-btn>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import atendimentoHibridoService from '@/services/atendimentoHibrido'

export default {
  data() {
    return {
      assinatura: null,
      loading: false
    }
  },
  computed: {
    ...mapState('fichaClinica', ['agendamento'])
  },
  methods: {
    async iniciarAtendimento() {
      const idAso = this.agendamento.idAso
      this.$store.commit('fichaClinica/RESET')
      const idAsoMeetingRoom = await this.entrarNaFila(idAso)
      this.$router.push({ name: 'fila-atendimento-hibrido', params: { id: idAsoMeetingRoom } })
    },
    async entrarNaFila(idAso) {
      try {
        this.loading = true
        const { data } = await atendimentoHibridoService.entrarNaFila(idAso)
        return data.id
      } catch (error) {
        console.log(error)
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
<style scoped> 
.card {
  height: 100%; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.img {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
</style>
